import {
  IAddUpdateDynamicPromoState,
  IAddUpdateVolumetricPromoState,
  IClientsResponseObject,
  IFilterPayload,
  IPromoProductSearchNormalized,
  IRolesResponseObject,
  IValidationObject,
} from "../interfaces/Index";
import {
  CLIENT_FILTER_ERROR_TEXT,
  CLIENT_ROLE_ERROR_TEXT,
  COMMANDO_CLIENT_ID,
  PROMO_VALIDATION_MESSAGES,
} from "../config/constants";
import { filter } from "lodash";

export const phoneNumberValidate = "/^d{11}$/";
export const alphaNumeric = "/^[0-9a-zA-Z]+$/";
export const numberOnly = "/^[0-9]*$/";
export const cnicNumberValidate = /^[0-9]{5}-[0-9]{7}-[0-9]{1}$/;
export const emailValidate = "/^[w-.]+@([w-]+.)+[w-]{2,4}$/";
export const numberWithCommaAndDot = /^[0-9., ]*$/;

export const alphaNumericValidator = (value: any) => {
  if (!value.match(/^[ A-Za-z0-9_@.,()/#&+-]*$/)) {
    return "Field accept alpha number characters only";
  }
};

export const numberOnlyValidator = (value: any) => {
  if (/[^\d+$\s]/.test(value)) {
    return "Field accept number only";
  }
};

export const positiveNegativeNumberValidator = (value: any) => {
  if (!/^-?\d*(.\d+)?$/.test(value)) {
    return "Field accept number only";
  }
};

export const decimalOnlyValidator = (value: any) => {
  if (!value.match(/^[0-9]+([,.][0-9]+)?$/g) && value !== "") {
    return "Field accept decimal number only";
  }
};

export const phoneNumberOnlyValidator = (value: any) => {
  const phoneNumber = /^[0][\d]{3}[\d]{7}$/;
  if (!value.match(phoneNumber) && value !== "") {
    return "Phone format should be e.g. 03451234567 or 02131234567 with 11 characters";
  }
};

export const emailAddressValidator = (value: any) => {
  const email = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  if (!value.match(email) && value !== "") {
    return "Please enter a valid email address (abc.xyz@bazaar-app.com)";
  }
};

export const coordinateOnlyValidator = (value: any) => {
  const coordinates = /^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/;
  if (!value.match(coordinates) && value !== "") {
    return "Field accept coordinates only";
  }
};

export const cnicNumberOnlyValidator = (value: any) => {
  const cnicNumberRegx = /^[0-9]{5}-[0-9]{7}-[0-9]{1}$/;
  if (!value.match(cnicNumberRegx) && value !== "") {
    return "CNIC number format should be e.g. 11111-1111111-1";
  }
};

export const numbersOnly = (text: string) => {
  const numberOnly = /^[0-9/-]*$/;
  return numberOnly.test(text);
};

interface validatorErrorObj {
  isError: boolean;
  errors: string[];
}

export const clientsRoleValidator = (
  roles: IRolesResponseObject[],
  clients: IClientsResponseObject[]
): validatorErrorObj => {
  const errObj: validatorErrorObj = {
    isError: false,
    errors: [],
  };

  if (clients.length === 0 && roles.length !== 0) {
    errObj.isError = true;
    errObj.errors.push(CLIENT_ROLE_ERROR_TEXT.selectClient);
  }

  // Checking if role has respective client
  roles.some((role) => {
    const index = clients.findIndex((client) => client.id === role.clientId);
    if (index < 0) {
      errObj.isError = true;
      errObj.errors.push(CLIENT_ROLE_ERROR_TEXT.roleMustHaveClient);
    }
  });

  // Check if client is not commando and associated role selected
  clients.some((client) => {
    if (client.id === COMMANDO_CLIENT_ID) {
      const index = roles.findIndex((role) => role.clientId === client.id);
      if (index < 0) {
        errObj.isError = true;
        errObj.errors.push(CLIENT_ROLE_ERROR_TEXT.selectRole);
      }
    }
  });

  return errObj;
};

export const checkPromoValidations = (
  promoProductData: IPromoProductSearchNormalized,
  promoStateData: IAddUpdateVolumetricPromoState | IAddUpdateDynamicPromoState
): IValidationObject => {
  const validateObj: IValidationObject = {
    isValidated: true,
    errorMessage: [],
  };

  // promoStateData.slabs.forEach((slab, index: number) => {
  //   if (promoProductData.stock <= slab.minUnits) {
  //     validateObj.isValidated = false;
  //     validateObj.errorMessage.push(
  //       `Slab ${index + 1}: ${
  //         PROMO_VALIDATION_MESSAGES.STOCK_LESS_THEN_SLAB_UNITS
  //       }`
  //     );
  //   }
  // });

  if (!promoProductData.categoryStatus) {
    validateObj.isValidated = false;
    validateObj.errorMessage.push(
      PROMO_VALIDATION_MESSAGES.SKU_CATEGORY_INACTIVE
    );
  }

  return validateObj;
};

export const clientAndFilterValidator = (
  filters: IFilterPayload[],
  clients: IClientsResponseObject[]
): validatorErrorObj => {
  const errObj: validatorErrorObj = {
    isError: false,
    errors: [],
  };

  // Checking if filter has respective client
  filters.some((filter: IFilterPayload) => {
    const index = clients.findIndex((client) => client.id === filter.clientId);
    if (index < 0) {
      errObj.isError = true;
      errObj.errors.push(CLIENT_FILTER_ERROR_TEXT.filterMustHaveClient);
    }
  });

  return errObj;
};

export function extractImageId(url: string | null | undefined): string | null {
  if (!url) return null;
  const match = url.match(/\/([^\/]+)$/);
  return match ? match[1] : null;
}
